import React from "react"
import ModalFormUI from "../../../widgets/form/ModalFormUI"
import InputDateUI from "../../../widgets/form/InputDateUI"
import InputCheckBoxUI from "../../../widgets/form/InputCheckBoxUI";
import InputSelectSF from "../../../widgets/form/InputSelectSF";
import InputTextSF from "../../../widgets/form/InputTextSF";

const InterestCollectionModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, onSubmit, submitted, onCancelClick,
  collectionDate, onCollectionDateChange, collectionDateError, setCollectionDateError,
  collectionAmount, onCollectionAmountChange, collectionAmountError, setCollectionAmountError,
  closeInvoice, onCloseInvoiceChange
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Customer fund utilization'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    {/* {
      !closeInvoice &&
      <> */}
    <InputTextSF type='text' name='collectionAmount' maxLength={40} label='Collection amount'
      value={collectionAmount} error={collectionAmountError}
      onChange={onCollectionAmountChange} setError={setCollectionAmountError}
    />

    <InputDateUI context={context} type='date' name='collectionDate'
      label='Collection date'
      selectedDateISO={collectionDate} onChange={onCollectionDateChange}
      error={collectionDateError} setError={setCollectionDateError}
    />
    {/* </>
    } */}

    <InputCheckBoxUI label='Close invoice' name='closeInvoice'
      onChange={onCloseInvoiceChange} checked={closeInvoice}
    />
  </ModalFormUI>

export default InterestCollectionModalUI;
